import lodashGet from 'lodash/get'

export default (props, traits) => {
  const banner = lodashGet(props, 'customSupporterPage.banner.url')
  const { colors, rhythm, shadows, mediaQuery } = traits

  return {
    banner: {
      maxHeight: rhythm(20),
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },

    image: {
      flexShrink: 0,
      width: '100%'
    },

    sidebar: {
      a: {
        maxWidth: '20em',
        width: '100%'
      },
      marginTop: banner && rhythm(-3),
      [mediaQuery('md')]: {
        marginTop: banner && rhythm(-7)
      },
      [mediaQuery('lg')]: {
        marginTop: banner && rhythm(-10)
      },

      '> div > * + *': {
        margin: rhythm([1.2, 0])
      },

      img: {
        maxWidth: '20em',
        margin: 'auto'
      }
    },

    main: {
      '> div > * + *': {
        margin: rhythm([2, 0])
      }
    },

    edit: {
      position: 'fixed',
      left: rhythm(1),
      bottom: rhythm(1),
      backgroundColor: colors.light,
      padding: rhythm([ 0.75, 1 ]),
      boxShadow: shadows.light,
      zIndex: 1
    },

    intro: {
      marginBottom: rhythm(0.5)
    }
  }
}
